import {JsonProperty} from '../shared/decorators/json-property';

export class BonusManualModel {
  @JsonProperty('user_id')
  id: string;
  @JsonProperty('first_name')
  firstName: string;
  @JsonProperty('middle_name')
  middleName: string;
  @JsonProperty('last_name')
  lastName: string;
  email: string;
  data: any;
  constructor() {
    this.id = undefined;
    this.firstName = undefined;
    this.middleName = undefined;
    this.lastName = undefined;
    this.email = undefined;
    this.data = undefined;
  }
  getUsername(): string {
    return (this.firstName) + ' ' + (this.lastName);
  }
}
export class BonusDepositModel {
  @JsonProperty('deposit_bonus_config_id')
  id: string;
  @JsonProperty('start_time')
  startTime: string;
  @JsonProperty('end_time')
  endTime: string;
  @JsonProperty('create_time')
  createTime: string;
  mode: boolean;
  constructor() {
    this.id = undefined;
    this.mode = undefined;
    this.startTime = undefined;
    this.endTime = undefined;
    this.createTime = undefined;
  }
}
